import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { ToastService } from '../../../services/toast.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ConfirmationPopupService } from '../../../services/confirmation-popup.service';
import { AuthService } from '../../../services/auth.service';
import { EventService } from '../../../services/event.service';

@Component({
  selector: 'invite-rsvp',
  standalone: false,
  templateUrl: './rsvp.component.html',
  styleUrl: './rsvp.component.css'
})
export class RsvpComponent {
  rsvpForm!: FormGroup;
  eventsList: { id: string; eventName: string, eventDate: Date }[] = [];
  isLoadingEvents: boolean = false;
  isLoaded = false;
  isSubmitting: boolean = false;
  eventOverview: any;
  isUpdate: boolean = false;
  showToast: boolean = false;
  currentUser!: any;

  @Output() onClose: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private apiService: ApiService,
    private authService: AuthService,
    private toastService: ToastService,
    private eventService:EventService,
    private confirmationPopup: ConfirmationPopupService
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.loadEvents();
    this.currentUser = this.authService.getCurrentUser();
    if (this.currentUser?.displayName) {
      this.rsvpForm.get('name')?.patchValue(this.currentUser?.displayName);
    }
  }

  initializeForm(): void {
    this.rsvpForm = this.fb.group({
      events: this.fb.array([]),
      name: new FormControl('', [Validators.required])
    });
  }

  get events(): FormArray {
    return this.rsvpForm.get('events') as FormArray;
  }

  loadEvents(): void {
    this.isLoadingEvents = true;

    this.eventService.getEvents().subscribe({
      next: (data: any[]) => {
        
        this.eventsList = data.map(event => ({
          id: event.id,
          eventName: event.title,
          eventDate: event.dates[0]
        }));
        this.isLoadingEvents = false;
        // this.loadExistingRsvp();
        this.isLoaded = true;

        data.forEach(rsvp => {
          this.events.push(
            this.fb.group({
              eventId: [rsvp.id, Validators.required],
              willAttend: [true],
              comments: [rsvp.comments]
            })
          );
        })
      }
    })
  }

  loadExistingRsvp(): void {
    this.apiService.getData('User/getUserRsvp').subscribe({
      next: (data: any[]) => {
        this.events.clear();
        this.updateFormWithExistingRsvp(data);
      }
    })
  }

  updateFormWithExistingRsvp(existingRsvpData: any[]) {
    this.isUpdate = existingRsvpData.some((x: any) => x.id != null);

    existingRsvpData.forEach(rsvp => {
      this.events.push(
        this.fb.group({
          eventId: [rsvp.eventId, Validators.required],
          willAttend: [rsvp.willAttend],
          comments: [rsvp.comments]
        })
      );
    });

    if (this.events.length === 0 && this.eventsList.length > 0) {
      this.eventsList.forEach(event => {
        this.events.push(
          this.fb.group({
            eventId: [event.id, Validators.required],
            willAttend: [false],
            comments: [''],
          })
        );
      });
    }
  }

  getEventName(eventId: string): string {
    return this.eventsList.find(e => e.id === eventId)?.eventName || 'Event';
  }

  getEventDate(eventId: string): Date | undefined {
    return this.eventsList.find(e => e.id === eventId)?.eventDate;
  }

  submitRsvp(): void {
    if (this.rsvpForm.invalid) {
      this.rsvpForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    const formValue = this.rsvpForm.value;
    const payload = [{
      name: formValue.name,
      eventResponses: formValue.events
    }];

    this.apiService.postData('Event/submitEventAttendance', payload).subscribe({
      next: () => {
        //this.openToast();
        this.toastService.success("Your response has been recorded successfully");
      },
      error: (err) => {
        console.error(err);
        this.toastService.error("Something went wrong. Please try later");
      }
    })

    // if (formValue.message && formValue.message.trim() != '') {
    //   let reqBody = { name: this.currentUser?.unique_name, message: formValue.message, email: this.currentUser?.email };
    //   this.apiService.postData('GuestBook/createPost', reqBody).subscribe({
    //     error: (err) => {
    //       console.error(err);
    //     }
    //   })
    // }
  }

  closeAddMessageModal(): void {
    this.events.clear();
    this.onClose.emit('close');
  }

  openToast() {
    this.showToast = true;
  }

  closeToast() {
    this.showToast = false;
  }

  onAccept() {
    window.open(this.eventOverview.saveEventUrl, '_blank');
    this.closeAddMessageModal();
  }

  onReject() {
    this.closeAddMessageModal();
  }
}